import React from 'react';
import { pushDataLayer } from 'ggApp/modules/tracking/actions';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    criteoHomePageTracking as criteoHomePageTrackingSelector,
    criteoProductTracking as criteoProductTrackingSelector,
    criteoCategoryTracking as criteoCategoryTrackingSelector,
    criteoSubCategoryTracking as criteoSubCategoryTrackingSelector,
    criteoConfirmationOrderTracking as criteoConfirmationOrderTrackingSelector,
} from 'ggApp/modules/criteo/selectors';

@connect(
    createStructuredSelector({
        criteoHomePageTracking: criteoHomePageTrackingSelector,
        criteoProductTracking: criteoProductTrackingSelector,
        criteoCategoryTracking: criteoCategoryTrackingSelector,
        criteoSubCategoryTracking: criteoSubCategoryTrackingSelector,
        criteoConfirmationOrderTracking: criteoConfirmationOrderTrackingSelector,
    }),
)
export default class CriteoDataLayerReporter extends React.Component {
    componentDidMount() {
        const payload = this.getEventPayload();
        pushDataLayer(payload);
    }

    shouldComponentUpdate() {
        return false;
    }

    getEventPayload() {
        const {
            type,
            criteoHomePageTracking,
            criteoProductTracking,
            criteoCategoryTracking,
            criteoSubCategoryTracking,
            criteoConfirmationOrderTracking,
        } = this.props;
        let eventPayload;
        switch (type) {
            case 'homePage':
                eventPayload = criteoHomePageTracking;
                break;
            case 'product':
                eventPayload = criteoProductTracking;
                break;
            case 'category':
                eventPayload = criteoCategoryTracking;
                break;
            case 'subCategory':
                eventPayload = criteoSubCategoryTracking;
                break;
            case 'orderConfirmation':
                eventPayload = criteoConfirmationOrderTracking;
                break;
            default:
                break;
        }
        return eventPayload;
    }

    render() {
        return null;
    }
}
